import type { Traveler } from "./types";
import type { TravelerInfo } from "@/api/car";

/** 与接口约定的人员类型（traveler_type） */
const TYPE_TO_API: Record<string, number> = {
  成人: 1,
  "儿童 (6-12岁)": 2,
  "幼儿 (<6岁)": 3,
};

const API_TO_TYPE: Record<number, string> = {
  1: "成人",
  2: "儿童 (6-12岁)",
  3: "幼儿 (<6岁)",
};

/** 订单详情 / 接口数据 → 表单 Traveler */
export function travelerFromApi(info: TravelerInfo): Traveler {
  const hasLicense = Boolean(
    info.license_number?.trim() ||
      info.license_front ||
      info.license_back ||
      info.license_type?.trim(),
  );
  return {
    name: info.name ?? "",
    phone: info.phone,
    type:
      info.traveler_type != null && API_TO_TYPE[info.traveler_type]
        ? API_TO_TYPE[info.traveler_type]
        : "成人",
    idCard: info.id_number ?? "",
    idCardFront: info.id_card_front,
    idCardBack: info.id_card_back,
    isDriver: hasLicense,
    licenseNo: info.license_number ?? "",
    licenseType: info.license_type ?? "",
    licenseExpiry: info.license_expire_date ?? "",
    licenseFront: info.license_front,
    licenseBack: info.license_back,
  };
}

/** 表单 Traveler → 确认订单接口 */
export function travelerToApi(t: Traveler): TravelerInfo {
  const base: TravelerInfo = {
    name: t.name.trim(),
    phone: t.phone?.trim() || undefined,
    traveler_type: TYPE_TO_API[t.type] ?? 1,
    id_number: t.idCard.trim(),
    id_card_front: t.idCardFront,
    id_card_back: t.idCardBack,
  };
  if (!t.isDriver) return base;
  return {
    ...base,
    license_number: t.licenseNo?.trim() || undefined,
    license_type: t.licenseType?.trim() || undefined,
    license_expire_date: t.licenseExpiry?.trim() || undefined,
    license_front: t.licenseFront,
    license_back: t.licenseBack,
  };
}

export function travelersToConfirmApi(list: Traveler[]): TravelerInfo[] {
  return list.map(travelerToApi);
}
